import React from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import ReactLoadingSkeleton, { SkeletonProps } from 'react-loading-skeleton';

const Skeleton: React.FC<SkeletonProps> = (props) => {
  return <ReactLoadingSkeleton {...props} />;
};

export default Skeleton;
